module.exports = __webpack_public_path__ + "media/images/getting-started/tiktok-edit-profile-8f1003270fae45df1540647a44477cee.png";